// extracted by mini-css-extract-plugin
export default {"publish_review_button":"styles_publish_review_button__ywcg2"};